export default "__VITE_ASSET__qV_ZT1W0__"